import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { CCommonPage } from "../../../models/page.models/commonPage.model";
import { CommonPageService } from "../../../services/commonPage.service";
import { Title, Meta } from "@angular/platform-browser";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { OnlineAnswerService } from "../../../services/onlineanswer.service";
import { CAnswerStatus } from "../../../models/onlineAnswer.models/answerStatus.model";

import { DOCUMENT } from "@angular/platform-browser";

@Component({
  selector: "onlineAnswering",
  templateUrl: "onlineAnswering.component.html",
})
export class OnlineAnsweringComponent implements OnInit {
  ngOnInit(): void {
    this.GetCommonPage();
    this.GetListShamsiYears();
  }

  commonPage: CCommonPage = new CCommonPage();
  id: string = "OnlineAnsweringIndex";
  yearNumberArray: number[] = [];
  answerStatus: CAnswerStatus = new CAnswerStatus();

  answerChecked: boolean = false;
  //0 - بیمار یافت نشد
  //1 - جواب آماده است
  //2 - جواب آماده نیست
  //3 - جواب آماده است اما بیمار دارای بدهی است
  answerStatusCode: number = 0;
  answerMessage: string = "";
  showLoadingGif: boolean = false;
  answerUrl: string = "";
  paymentUrl: string = "";
  showErrorMessage: boolean = false;
  errorMessage: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private onlineAnswerService: OnlineAnswerService,
    private commonPageService: CommonPageService,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) document: any
  ) {}

  yearNumber: FormControl = new FormControl("", [Validators.required]);
  acceptionNumber: FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(4),
  ]);
  phoneNumber: FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(8),
  ]);

  onlineAnsweringForm: FormGroup = this.formBuilder.group({
    yearNumber: this.yearNumber,
    acceptionNumber: this.acceptionNumber,
    phoneNumber: this.phoneNumber,
  });

  GetCommonPage() {
    this.commonPageService.GetById(this.id).subscribe((data: CCommonPage) => {
      this.commonPage = data;
      if (this.router.url === "/OnlineAnswering") {
        this.SetPageMetaData(data);
      }
    });
  }

  SetPageMetaData(model: CCommonPage) {
    this.titleService.setTitle(model.fMetaTitle);
    this.metaService.updateTag({
      name: "description",
      content: model.fMetaDescription,
    });
    this.metaService.updateTag({
      name: "keywords",
      content: model.fMetaKeywords,
    });
  }

  GetListShamsiYears() {
    this.onlineAnswerService
      .GetListShamsiYears()
      .subscribe((data: number[]) => {
        this.yearNumberArray = data;
        if (this.yearNumberArray.length > 0) {
          this.yearNumber.setValue(this.yearNumberArray[0]);
        }
      });
  }

  CheckAnswer() {
    var accN: string = this.yearNumber.value + this.acceptionNumber.value;
    var acceptionCode: string = accN.replace("-", "");

    var phone: string = this.phoneNumber.value;

    this.showLoadingGif = true;
    this.answerChecked = false;
    this.showErrorMessage = false;
    this.errorMessage = "";

    this.onlineAnswerService.GetStatusAnswer(acceptionCode, phone).subscribe(
      (data: CAnswerStatus) => {
        this.answerStatus = data;

        this.answerChecked = true;
        this.answerStatusCode = this.answerStatus.fAnswerStatus;
        this.answerUrl = "";

        switch (this.answerStatus.fAnswerStatus) {
          case 0: {
            this.answerMessage = "بیماری با این مشخصات یافت نشد";
            break;
          }
          case 1: {
            this.answerMessage = "جواب آزمایش شما آماده می باشد";
            this.answerUrl = this.onlineAnswerService.GetDownloadAnswerUrl(
              acceptionCode,
              phone
            );
            break;
          }
          case 2: {
            this.answerMessage = "جواب آزمایش شما آماده نمی باشد";
            break;
          }
          case 3: {
            this.answerMessage =
              "جواب آزمایش شما آماده می باشد. لطفا برای دریافت جواب آزمایش ابتدا تسویه حساب نمایید";
            var thisSiteUrl = document.location.origin;
            var fReturnUrlSuccess =
              thisSiteUrl +
              "/PaymentSucceeded?key=" +
              acceptionCode +
              "_" +
              phone;
            var fReturnUrlFailure = thisSiteUrl + "/PaymentFailure";
            this.paymentUrl = this.onlineAnswerService.GetAcceptionPaymentUrl(
              this.answerStatus.fCode.toString(),
              fReturnUrlSuccess,
              fReturnUrlFailure
            );
            break;
          }
        }

        this.showLoadingGif = false;
      },
      (err) => {
        this.showLoadingGif = false;
        this.errorMessage =
          "متاسفانه ارتباط با سرور برقرار نیست. لطفا مجددا سعی نمایید";
        this.showErrorMessage = true;
      }
    );
  }
}
